export type OrgStructureRow = {
  positionId: string;
  title: string;
  department?: string;
  managerPositionId: string | null;
  isManager: boolean;
  personId?: string | null;
  personName?: string | null;
  unitId?: string | null;
  location?: string | null;
  level?: string | null;
  notes?: string | null;
};

/** The optional authored business function; never derived from title or unit. */
export function parseOrgDepartment(value: unknown): string | undefined {
  if (value === undefined || value === null) return undefined;
  if (typeof value !== 'string') throw new Error('department must be a string when provided');
  if (value.includes('\r') || value.includes('\n')) throw new Error('department must be a single line');
  return value.trim() || undefined;
}
